import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "@/components/Hero";
import Story from "@/components/Story";
import Features from "@/components/Features";
import BeforeAfter from "@/components/BeforeAfter";
import Gallery from "@/components/Gallery";
import Testimonials from "@/components/Testimonials";
import Contact from "@/components/Contact";

export default function Landing() {
  const location = useLocation();

  useEffect(() => {
    const target = location.state?.scrollTo;
    if (target) {
      const t = setTimeout(() => {
        const el = document.getElementById(target);
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
          else el.scrollIntoView();
        }
      }, 250);
      return () => clearTimeout(t);
    }
  }, [location]);

  return (
    <main>
      <Hero />
      <Story />
      <Features />
      <BeforeAfter />
      <Gallery />
      <Testimonials />
      <Contact />
    </main>
  );
}
